import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TajikistanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_16024'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_16024)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#D9101C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#0F7811'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52316 6.06664C9.52316 6.32438 9.30996 6.53331 9.04697 6.53331C8.78398 6.53331 8.57078 6.32438 8.57078 6.06664C8.57078 5.80891 8.78398 5.59998 9.04697 5.59998C9.30996 5.59998 9.52316 5.80891 9.52316 6.06664ZM10.4755 6.99998C10.4755 7.08439 10.4527 7.26368 10.4127 7.46664H10.9613C11.219 7.46664 11.4279 7.67558 11.4279 7.93331C11.4279 8.19104 11.219 8.39998 10.9613 8.39998H9.99935H9.03745C8.77971 8.39998 8.57078 8.19104 8.57078 7.93331C8.57078 7.67558 8.77971 7.46664 9.03744 7.46664H9.58602C9.54603 7.26368 9.52316 7.08439 9.52316 6.99998C9.52316 6.74224 9.73636 6.53331 9.99935 6.53331C10.2623 6.53331 10.4755 6.74224 10.4755 6.99998ZM11.4279 6.06664C11.4279 6.32438 11.2147 6.53331 10.9517 6.53331C10.6887 6.53331 10.4755 6.32438 10.4755 6.06664C10.4755 5.80891 10.6887 5.59998 10.9517 5.59998C11.2147 5.59998 11.4279 5.80891 11.4279 6.06664ZM12.8565 7.46664C13.1195 7.46664 13.3327 7.25771 13.3327 6.99998C13.3327 6.74224 13.1195 6.53331 12.8565 6.53331C12.5935 6.53331 12.3803 6.74224 12.3803 6.99998C12.3803 7.25771 12.5935 7.46664 12.8565 7.46664ZM7.6184 6.99998C7.6184 7.25771 7.4052 7.46664 7.14221 7.46664C6.87921 7.46664 6.66602 7.25771 6.66602 6.99998C6.66602 6.74224 6.87921 6.53331 7.14221 6.53331C7.4052 6.53331 7.6184 6.74224 7.6184 6.99998Z'
					fill='#FAD14E'
				/>
			</g>
		</svg>
	);
};

export default TajikistanFlagIcon;
